(function(){
  var KEY = 'lz_wishlist';
  function get(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function save(a){ localStorage.setItem(KEY, JSON.stringify(a)); updateCount(); }
  function has(h){ return get().indexOf(h) > -1; }
  function toggle(h){ var a=get(); var i=a.indexOf(h); if(i>-1){a.splice(i,1);} else {a.push(h);} save(a); return i===-1; }
  function updateCount(){ var n=get().length; document.querySelectorAll('.lz-wishcount').forEach(function(el){ el.textContent=n; el.classList.toggle('hidden-count', n===0); }); }
  function markButtons(){ document.querySelectorAll('.lz-wish-btn').forEach(function(b){ b.classList.toggle('is-saved', has(b.getAttribute('data-handle'))); }); }
  function money(cents){ return (cents/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}) + ' \u20AC'; }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.lz-wish-btn');
    if(btn){ e.preventDefault(); var saved=toggle(btn.getAttribute('data-handle')); btn.classList.toggle('is-saved', saved); return; }
    var rm = e.target.closest('.lz-wish-remove');
    if(rm){ e.preventDefault(); toggle(rm.getAttribute('data-handle')); var card=rm.closest('.lz-item'); if(card)card.remove(); if(!get().length){ var em=document.getElementById('lzWishEmpty'); if(em)em.style.display='block'; } markButtons(); }
  });

  function renderPage(){
    var wrap = document.getElementById('lzWishlist');
    if(!wrap) return;
    var handles = get();
    var empty = document.getElementById('lzWishEmpty');
    if(!handles.length){ if(empty) empty.style.display='block'; return; }
    if(empty) empty.style.display='none';
    handles.forEach(function(h){
      fetch('/products/' + h + '.js').then(function(r){ return r.json(); }).then(function(p){
        var v = p.variants[0];
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var desc = p.description ? p.description.replace(/<[^>]+>/g,'').slice(0,220) : '';
        var card = document.createElement('div');
        card.className = 'lz-item';
        card.innerHTML =
          '<div class="lz-item__media"><a href="'+p.url+'">'+(img?'<img src="'+img+'" width="200" height="200" alt="">':'')+'</a>'+
            '<div class="lz-sticker"><span class="lz-sticker__price">'+money(p.price)+'</span></div></div>'+
          '<div class="lz-item__info"><h3 class="lz-item__title"><a href="'+p.url+'" class="link-hover">'+p.title+'</a></h3>'+
            '<div class="lz-item__desc">'+desc+'</div>'+
            '<div class="lz-actions"><div class="lz-actions__links"><button type="button" class="lz-action-link lz-wish-remove" data-handle="'+h+'"><i class="fas fa-times"></i> Entfernen</button></div>'+
            '<form action="/cart/add" method="post"><input type="hidden" name="id" value="'+v.id+'"><input type="hidden" name="quantity" value="1"><button type="submit" class="lz-btn bg-color">In den Warenkorb</button></form></div></div>';
        wrap.appendChild(card);
      }).catch(function(){});
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ markButtons(); updateCount(); renderPage(); });
})();